import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../Escritorio/Instrucciones';
import useConfigAuth from '../../../../../Hooks/useConfigAuth';
import BotoneraBottom from '../../../Compartidos/BotoneraBottom';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../actions/almacenarEjercicioActions';

import { Flex, FlexFull, ImgB10, AvanzarImg, AvanzarBtn, InputM68, P, BtnNumberM9, CirculoConLineas, NumCalculoM83 } from '../../../../Css/StyledMatematica' ;
import { BtnBottom } from '../../../../Css/MetodosCSS/StyledLetras';
import { Img } from '../../../../Css/StyledActivities';

const instrucciones = '';
const miniInstrucciones = '';

const M90 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [numero1, setNumero1] = useState('');
    const [numero2, setNumero2] = useState('');
    const [numero3, setNumero3] = useState('');
    const [numero4, setNumero4] = useState('');
    const [numero5, setNumero5] = useState('');
    const [numero6, setNumero6] = useState('');
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const sesion = useSelector((state) => state.ejercicio.sesion);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const moverse = (e,nro) => {
        e.preventDefault();
        if(nro === 1) {
            if(count === 4) {
                    setCount(count+1);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                    setNumero4('');
            } else if(count === 18) {
                    setCount(count+1);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                    setNumero4('');
                    setNumero5('');
                    setNumero6('');
            } else {
                setCount(count+1);
            }
        } else {
            if(count == 5) {
                setCount(count-2);
            } else if(count == 10){
                setCount(count-5);
            } else if(count == 19){
                setCount(count-5);
            } else {
                setCount(count-1)
            }
        }
    }

    const verificar = (e, dato) => {
        e.preventDefault();
        
        if(count === 1) {
            if(numero1 == 3 && numero2 == 2 && numero3 == 6 ){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    return;
                }, 300);
            }
        } else if(count === 2) {
            if(dato === "juntar") {
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    return;
                }, 300);
            }
        } else if(count === 3){
            if(numero1 == 2 && numero2 == 2 && numero3 == 2 && numero4 == 6 ){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                    setNumero4('');
                    return;
                }, 300);
            }
        } else if(count === 7){
            if(numero1 == 3){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero1('');
                    return;
                }, 300);
            }
        } else if(count === 8){
            if(numero2 == 2){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero2('');
                    return;
                }, 300);
            }
        } else if(count === 9){
            if(numero3 == 6){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero3('');
                    return;
                }, 300);
            }
        } else if(count === 14){
            if(numero1 == 3 && numero2 == 2 && numero3 == 6){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                    return;
                }, 300);
            }
        } else if(count === 15){
            if(numero4 == 3 && numero5 == 2 && numero6 == 6){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero4('');
                    setNumero5('');
                    setNumero6('');
                    return;
                }, 300);
            } 
        } else if(dato == "ultimo") {
            if(numero1 == 4 && numero2 == 4 && numero3 == 4 ){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                    return;
                }, 300);
            }
        }
        
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('M90') );
        dispatch(setearUrlAnteriorAction('matematica/calculo/multiplicacion/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    useEffect(() => {
        if (count != 20) {
            return;
        } else {
            dispatch(finalizarEjercicioAction());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count])

    useEffect(() => {
        if(!finalizar) {
            return;
        }
        const informacion = {
            config,
            payload: {
            'ejercicio': 'M90',
            'id_paciente': id_paciente,
            sesion
            }
        }
        dispatch( almacenarAction(informacion) );
        navigate("/escritorio/metodos/finalizar-ejercicio");
    }, [finalizar])

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} />
            {iniciar
                ?
                <Flex direction="column" height="100%" width="100%" align="center">
                    {count === 1 ?
                        <Flex margin="auto" width="100%" align='center'
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull direction="column" justify="space-between" align="center" margin="0 1rem 0 6rem">
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="9rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="9rem" m="1rem 0 0 0" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="9rem" m="1rem 0 0 0" />
                            </FlexFull>
                            <FlexFull flex="1" margin="0 3rem 0 3rem" maxw="1.2rem" style={{borderLeft: "2px solid black",height: "100%"}}>
                            </FlexFull>
                            <FlexFull direction="column" justify="space-between" align="center" margin="auto">
                                <FlexFull>
                                    <P>
                                        HAY{" "}
                                        <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem"}} />{" "}
                                        BICILETAS.
                                    </P>
                                </FlexFull>
                                <FlexFull>
                                    <P>
                                        CADA BICI TIENE{" "}
                                        <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem"}} />{" "}
                                        RUEDAS.
                                    </P>
                                </FlexFull>
                                <FlexFull>
                                    <P>
                                        EN TOTAL HAY{" "}
                                        <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem"}} />{" "}
                                        RUEDAS.
                                    </P>
                                </FlexFull>
                            </FlexFull>
                        </Flex>
                    : count === 2 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull justify="space-between" align="center" margin="0 0 1rem 0">
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" m="0 0 0 1rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" m="0 0 0 1rem"/>
                            </FlexFull>
                            <FlexFull justify="center" align="center">
                                <P fs="4rem" >
                                    ¿QUÉ TUVE QUE HACER?
                                </P>
                            </FlexFull>
                            <FlexFull justify="space-between" align="center">
                                <BtnNumberM9 style={{fontSize: "3rem", width: "27vw", height: "20vh"}}
                                    disabled={disable}
                                    onClick={(e) => verificar(e, "juntar")}
                                >
                                    JUNTAR
                                </BtnNumberM9>
                                <BtnNumberM9 style={{fontSize: "3rem", width: "27vw", height: "20vh"}}
                                    disabled={disable}
                                    onClick={(e) => verificar(e, "quitar")}
                                >
                                    QUINTAR
                                </BtnNumberM9>
                            </FlexFull>
                        </Flex>
                    : count >= 3 && count <= 4 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull justify="space-between" align="center" margin="0 0 1rem 0">
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" m="0 0 0 1rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" m="0 0 0 1rem" />
                            </FlexFull>
                            <FlexFull justify="center" align="center" margin="0 1.5rem 0 1.5rem">
                                <P fs="2rem" >
                                    ¿QUÉ OPERACIÓN TENGO QUE HACER PARA SABER CUANTAS RUEDAS HAY?
                                </P>
                            </FlexFull>
                            <FlexFull justify="space-between" align="center" margin="auto">
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull>
                                    <P>+</P>
                                </FlexFull>
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull>
                                    <P>+</P>
                                </FlexFull>
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull>
                                    <P>=</P>
                                </FlexFull>
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero4} onChange={(e) => setNumero4(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                            </FlexFull>
                            {count == 4 ? 
                            <FlexFull justify="center" align="center" margin="0 1rem 0 1rem">
                                <P fs="2rem" >
                                    TE ENSEÑO UNA FORMA MÁS CORTA DE HACERLO
                                </P>
                            </FlexFull>
                            : null }
                        </Flex>
                    : count >= 5 && count <= 9 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull justify="space-between" align="center" margin="0 0 4rem 0">
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" m="0 0 0 1rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="11rem" m="0 0 0 1rem" />
                            </FlexFull>
                            <FlexFull justify="space-between" align="flex-start" margin="auto">
                                {count >= 7 ? 
                                <FlexFull>
                                    <P>¿CUÁNTAS <br /> BICIS HAY?</P>
                                </FlexFull>
                                : null}
                                {count >= 7 ? 
                                <FlexFull>
                                    <ImgB10 src={`/img/arrowRight.png`} h='3rem' tr='rotate(180deg)' />
                                </FlexFull>
                                : null}
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={count != 7 ? true : disable} color='#FF9B2A' bgcolor={count >= 7 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" margin="0.5rem 0.5rem 0.5rem">
                                    <P fs="2.5rem" m="0">X</P>
                                    {count >= 6 ? 
                                    <FlexFull direction="column" align="center" justify="center" height="">
                                        <ImgB10 src={`/img/arrowRight.png`} h='3rem' tr='rotate(90deg)' />
                                        <P>
                                            VECES
                                        </P>
                                    </FlexFull>
                                    : null}
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" >
                                    <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={count != 8 ? true : disable} color='#FF9B2A' bgcolor={count >= 8 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                    {count >= 8 ? 
                                    <FlexFull direction="column" align="center" justify="center" height="">
                                        <ImgB10 src={`/img/arrowRight.png`} h='5rem' tr='rotate(90deg)' />
                                        <P>
                                            ¿CUÁNTAS <br /> RUEDAS TIENE <br /> CADA BICI?
                                        </P>
                                    </FlexFull>
                                    : null}
                                </FlexFull>
                                <FlexFull align="center" justify="center" margin="0.6rem 0.2rem 0.2rem">
                                    <P fs="2rem" m="0">=</P>
                                </FlexFull>
                                <FlexFull align="center" justify="center">
                                    <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={count != 9 ? true : disable} color='#FF9B2A' bgcolor={count >= 9 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                {count >= 9 ? 
                                <FlexFull align="center" justify="center" height="">
                                    <ImgB10 src={`/img/arrowRight.png`} h='3rem' />
                                    <P>
                                        RUEDAS EN <br /> TOTAL
                                    </P>
                                </FlexFull>
                                : null}
                            </FlexFull>
                        </Flex>
                    : count >= 10 && count <= 12 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull justify="space-between" align="flex-start" margin="5rem 0 0 0">
                                <FlexFull direction="column" align="center" justify="center" margin="0 1rem 1rem 0">
                                    <P fs="6rem" m="0">X</P>
                                    {count >= 12 ? 
                                    <FlexFull align="center" justify="center">
                                        <ImgB10 src={`/img/arrowRight.png`} h='6rem' tr='rotate(90deg)' />
                                        
                                    </FlexFull>
                                    : null}
                                    {count >= 12 ? 
                                    <FlexFull align="center" justify="center">
                                        <P>
                                            VECES
                                        </P>
                                    </FlexFull>
                                    : null}
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" >
                                    {count >= 11 ? 
                                    <FlexFull align="center" justify="center">
                                        <ImgB10 src={`/img/arrowRight.png`} h='6rem' />
                                        <P m="0 0 0 1rem">
                                            SIGNO POR
                                        </P>
                                    </FlexFull>
                                    : null}
                                </FlexFull>
                            </FlexFull>
                        </Flex>
                    : count >= 13 && count <= 18 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull justify="space-between" align="center" margin="0 0 1.2rem 0">
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="10rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="10rem" m="0 0 0 1rem" />
                                <ImgB10 src={`/img/bicicleta.png`} w="9rem" wd="9rem" wlg="10rem" m="0 0 0 1rem" />
                            </FlexFull>
                            {count >= 14 ? 
                            <FlexFull justify="space-between" align="center" margin="1.5rem 0 1.5rem 0">
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" margin="0.5rem 0.5rem 0.5rem">
                                    <P fs="2.5rem" m="0">X</P>
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" >
                                    <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull align="center" justify="center" margin="0.6rem 0.2rem 0.2rem">
                                    <P fs="2rem" m="0">=</P>
                                </FlexFull>
                                <FlexFull align="center" justify="center">
                                    <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                            </FlexFull>
                            : null }
                            {count >= 15 ? 
                            <FlexFull justify="space-between" align="center" margin="1.2rem 0 1.2rem 0">
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero4} onChange={(e) => setNumero4(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" margin="0.5rem 0.5rem 0.5rem">
                                    <P fs="2.5rem" m="0">VECES</P>
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" >
                                    <InputM68 type="numeric" min="1" max="10" value={numero5} onChange={(e) => setNumero5(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull align="center" justify="center" margin="0.6rem 0.2rem 0.2rem">
                                    <P fs="2rem" m="0">=</P>
                                </FlexFull>
                                <FlexFull align="center" justify="center">
                                    <InputM68 type="numeric" min="1" max="10" value={numero6} onChange={(e) => setNumero6(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                            </FlexFull>
                            : null }
                            {count >= 16 ? 
                            <FlexFull justify="space-between" align="center" margin="1rem 0 0 0">
                                <FlexFull margin="0 1rem 0 0">
                                    <CirculoConLineas />
                                </FlexFull>
                                {count >= 17 ? 
                                <FlexFull margin="0 1rem 0 1rem">
                                    <CirculoConLineas />
                                </FlexFull>
                                : null }
                                {count >= 18 ? 
                                <FlexFull margin="0 0 0 1rem">
                                    <CirculoConLineas />
                                </FlexFull>
                                : null }
                            </FlexFull>
                            : null }
                        </Flex>
                    : count >= 19 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull align="center" justify="center" margin="1.5rem 0 1.5rem 0">
                                <NumCalculoM83 color='#646464'>3</NumCalculoM83>
                                <NumCalculoM83 color='#23AAAF'>X</NumCalculoM83>                                     
                                <NumCalculoM83 color='#646464'>4</NumCalculoM83>
                            </FlexFull>
                            
                            <FlexFull align="center" justify="center" margin="0 0 0 0">
                                <P fs="4rem" m="0">=</P>
                            </FlexFull>
                            <FlexFull justify="space-between" align="center" margin="1.5rem 0 1.5rem 0">
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" margin="0.5rem 0.5rem 0.5rem">
                                    <P fs="2.5rem" m="0">+</P>
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" >
                                    <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" margin="0.5rem 0.5rem 0.5rem">
                                    <P fs="2.5rem" m="0">+</P>
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" >
                                    <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                            </FlexFull>
                        </Flex>
                    : null }
                    {count === 1 ?
                        <Flex margin="0 0rem 0.5rem 0rem" width="90%" justify="end">
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                            <AvanzarBtn
                                disabled={disable}
                                onClick={(e) => verificar(e)}
                            >
                                <AvanzarImg src={'/img/play.png'} /> 
                            </AvanzarBtn>
                        </Flex>
                    : count >= 3 && count <= 19 ?
                        <Flex margin="0 0rem 0.5rem 0rem" width="90%" justify="end">
                            <BtnBottom
                                onClick={(e) => moverse(e,-1)}
                                disabled={disable}
                            >
                                <Img src={`/img/icono_retroceder.png`} alt="" width='3.5rem' height="3rem" />
                            </BtnBottom>
                            {count == 3 || count == 7 || count == 8 || count == 9 || count == 14 || count == 15 || count == 19 ? 
                            <AvanzarBtn
                                disabled={disable}
                                onClick={(e) => verificar(e,"ultimo")}
                            >
                                <AvanzarImg src={'/img/play.png'} /> 
                            </AvanzarBtn>
                            :
                            <BtnBottom
                                onClick={(e) => moverse(e,1)}
                                disabled={disable}
                            >
                                <Img src={`/img/icono_avanzar.png`} alt="" width='3.5rem' height="3rem" />
                            </BtnBottom>
                            }
                        </Flex>
                    : null}
                </Flex>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default M90;